<template>
  <RevLoadingScreen
    class="fixed inset-0"
    data-qa="loading-screen"
    data-test="loading-screen"
    :text="i18n(translations.loading)"
  />
</template>

<script lang="ts" setup>
import { onMounted } from 'vue'

import { useLogout } from '@backmarket/nuxt-layer-oauth/useLogout'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevLoadingScreen } from '@ds/components/LoadingScreen'

import translations from './Logout.translations'

const i18n = useI18n()

const { logout } = useLogout()

onMounted(async () => {
  await logout()
})
</script>
